import { z } from 'zod';
import { AssetTypeSchema, TrayType, TrayTypeSchema } from './asset-api.dto';

export const AvailableAssetCatalogLocationDtoSchema = z.object({
  locationId: z.string().nullable(),
  locationName: z.string(),
  count: z.number(),
});
export type AvailableAssetCatalogLocationDto = z.infer<
  typeof AvailableAssetCatalogLocationDtoSchema
>;

/**
 * Tray-specific template details on a TRAY catalog. Physical trays inherit
 * this tray type from the catalog.
 */
export const TrayCatalogDetailsDtoSchema = z.object({
  trayType: TrayTypeSchema,
});

export type TrayCatalogDetailsDto = z.infer<typeof TrayCatalogDetailsDtoSchema>;

export const AssetCatalogItemDtoSchema = z.object({
  id: z.string(),
  type: AssetTypeSchema,
  name: z.string(),
  description: z.string().nullable(),
  manufacturer: z.string(),
  productNumber: z.string(),
  metadata: z.record(z.unknown()).nullish(),
  isActive: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  availableCount: z.number(),
  availableAssetLocations: z.array(AvailableAssetCatalogLocationDtoSchema),
  trayDetails: TrayCatalogDetailsDtoSchema.nullish(),
});
export type AssetCatalogItemDto = z.infer<typeof AssetCatalogItemDtoSchema>;

export const PaginatedAssetCatalogResponseDtoSchema = z.object({
  data: z.array(AssetCatalogItemDtoSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});
export type PaginatedAssetCatalogResponseDto = z.infer<
  typeof PaginatedAssetCatalogResponseDtoSchema
>;

export interface AssetCatalogFilterParams {
  search?: string;
  name?: string;
  type?: string;
  isActive?: boolean;
  page?: number;
  limit?: number;
}

export interface CreateAssetCatalogDto {
  type: string;
  name: string;
  manufacturer: string;
  productNumber: string;
  description?: string | null;
  metadata?: Record<string, unknown> | null;
  isActive?: boolean;
  /** Tray-specific template details. Only applies to TRAY catalogs. */
  trayDetails?: { trayType: TrayType };
}

export interface UpdateAssetCatalogDto {
  name?: string;
  description?: string | null;
  metadata?: Record<string, unknown> | null;
  isActive?: boolean;
}
